import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { QueryRequest } from 'src/app/reports/requests/query.request';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { EntityColumnHeaders } from 'src/app/reports/models/query/entity-column-headers.model';
import { QueryService } from 'src/app/reports/services/query.service';
import { Column } from 'src/app/reports/components/report/models/column.model';
import { ReportEntity } from 'src/app/reports/components/report/models/report-entity.model';
import { ColumnHeader } from 'src/app/reports/models/query/column-header.model';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';

@Component({
  animations:[
    trigger('item-visiability',[
      state('hidden', style({
        display: 'none',
        height: '0px',
      })),
      state('visible', style({
        display: 'block'
      })),
      transition('hidden => visible', animate('500ms 0s ease-in')),
      transition('visible => hidden', animate('100ms 0s ease-out'))
    ])
  ],
  selector: 'app-entity-item',
  templateUrl: './entity-item.component.html',
  styleUrls: ['./entity-item.component.scss']
})
export class EntityItemComponent extends BaseComponent implements OnInit,OnDestroy {

  //#region Inputs
  @Input() disabled : boolean = false;
  @Input() entity : ReportEntity;
  @Input() showCollapsed : boolean = false;
  @Input() showExpandedIcon : boolean = true;
  @Input() showDeleteButton : boolean = false;
  @Input() showMainButton : boolean = false;
  @Input() enableScrollOnDetail : boolean = false;
  @Input() showDragHandlerOnDetail : boolean = false;

  @Input() columnDragulaGroup : string;
  @Input() linkGroupName: string;

  //#endregion

  //#region outputs

  @Output() onDelete : EventEmitter<any> = new EventEmitter<any>();
  @Output() onMainChanged : EventEmitter<any> = new EventEmitter<any>();

  //#endregion

  //#region Properties

  columns : Array<Column> = new Array<Column>();
  visiability : string = 'hidden';
  isActive: boolean = false;

  editIsEnable : boolean = false;

  //#endregion

  //#region Ctor

  constructor(private queryService : QueryService) {
    super();
  }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {

    if(this.showCollapsed){
      this.getColumnHeaders();
      this.visiability = 'visible';
    }
  }

  //#endregion

  //#region Detail Methods

  expand(){
    if(this.showExpandedIcon){
      this.isActive = !this.isActive;

      if(this.isActive) {

        if(this.columns.length == 0){
          this.getColumnHeaders();
        }

        this.visiability = 'visible';
      }
      else
        this.visiability = 'hidden';
    }
  }

  getColumnHeaders() : void{
    let find : EntityColumnHeaders = this.queryService.getEntityColumnHeader(this.entity.EntityId);

    if(find == null){

      let obj : QueryRequest = {
        ProviderId: this.entity.Entity.Provider.Id,
        Query : this.entity.Entity.Query
      };

      this.subscription.add(
        this.queryService.columnHeader(obj).subscribe(result => this.afterLoadColumnHeaders(result))
      );
    }
    else
      this.afterLoadColumnHeaders(find.Columns);
  }

  afterLoadColumnHeaders(columns: ColumnHeader[]) {
    this.columns = this.queryService.converColumnHeadersToColumns(columns, this.entity);
    this.queryService.storeEntityColumnHeader(this.entity.EntityId, columns);
    this.entity.Columns.forEach(column => {
      let aux = this.columns.find(x => x.Name.toUpperCase() == column.Name.toUpperCase());
      if (aux){
        column.SystemType = aux.SystemType;
        column.Type = aux.Type;
        column.IsPrimaryKey = aux.IsPrimaryKey;
      }
    });
  }

  //#endregion

  //#region Click Events

  onDeleteClick(){
    if(!this.disabled)
      this.onDelete.emit(this.entity);
  }

  onMainClick(){
    if(!this.disabled)
      this.onMainChanged.emit(this.entity);
  }

  //#endregion
}
